import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';


import axios from 'axios';

const PaymentPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const {
    razId,
    amount,
    orderId,
    name,
    phone,
    email,
    address
  } = location.state || {};

  const [timeout, seTimeOut] = useState(false);
  const [count, setCount] = useState(20);

  useEffect(() => {
    const timer = setTimeout(() => {
      seTimeOut(true);
    }, 20000);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (count === 0) return;

    const timer = setTimeout(() => {
      setCount(prev => prev - 1);
    }, 1000);

    return () => clearTimeout(timer);
  }, [count]);

useEffect(() => {
  if (!razId) return;

  const script = document.createElement("script");
  script.src = "https://checkout.razorpay.com/v1/checkout.js";
  script.async = true;
  document.body.appendChild(script);

  script.onload = () => {
    const options = {
      key: "rzp_test_BhFCfPyz0TQ5di",
      amount: amount * 100,
      currency: "INR",
      name: "Welbeing",
      description: "Carry The Future",
      image: "https://welbeing.in/assets/img/logo/logo-1.png",
      order_id: razId,
      handler: function (response) {
      const Data = new FormData();
      Data.append("payment_id", response.razorpay_payment_id);
      Data.append("order_id", orderId);

      axios.post("https://api.welbeing.in/payment/razorpay-process/", Data)
        .then((res) => {
          sessionStorage.setItem("paymentCompleted", "true");
          window.location.href = `/payment-status?status=${res?.data?.status}&payment_id=${res.data.payment_id}&order_id=${orderId}`;
        })
        .catch((err) => {
          sessionStorage.setItem("paymentCompleted", "true");
          window.location.href = `/payment-status?status=failed&order_id=${orderId}`;
        });
    },
      prefill: {
        name,
        email,
        contact: phone
      },
      notes: {
        address
      },
      theme: {
        color: "#911077"
      }
    };

    const rzp1 = new window.Razorpay(options);
    window.rzpInstance = rzp1; 

    rzp1.on('payment.failed', function (response) {
      //alert(response.error.description);
      window.location.href = `/payment-status?status=failed&order_id=${orderId}`;
    });

    rzp1.open();
  };
}, [razId, amount, orderId, name, phone, email, address]);

  return (
      <div className="preloader show" style={{
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  // backgroundColor: 'rgba(255,255,255,0.9)', // optional background
  zIndex: 9999
}}>
  <div className="biof-loading-center">
    <div className="biof-loading-center-absolute">
      <div className="dot dot-one"></div>
      <div className="dot dot-two"></div>
      <div className="dot dot-three"></div>
    </div>
  </div>
  <small style={{
    marginTop: '20px',
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }}>
    {timeout ? <a href="/" style={{padding: '10px 20px', border: 'none', borderRadius: '10px', background: '#54aa62', color: '#fff', fontWeight: 'bold'}}>Home</a> : `Do not press the back button or refresh page. ${count}` }
  </small>
</div>
    // <div className="preloader show">
    //   <div className="biof-loading-center">
    //     <div className="biof-loading-center-absolute">
    //       <div className="dot dot-one"></div>
    //       <div className="dot dot-two"></div>
    //       <div className="dot dot-three"></div>
    //     </div>
    //   </div>
    //   <small align="center" style={{display:"flex", alignItems:'center', justifyContent:'center'}}>Do not press the back button or refresh page.</small>
    // </div>
  
  );
};

export default PaymentPage;
